import { render } from "./Pand.vue?vue&type=template&id=01959cf5&scoped=true"
import script from "./Pand.vue?vue&type=script&lang=js"
export * from "./Pand.vue?vue&type=script&lang=js"

import "./Pand.vue?vue&type=style&index=0&id=01959cf5&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01959cf5"]])

export default __exports__